import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Flag = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4H11V8.11115L5 8.11115V4ZM4 3.55447V3H5H11C11.5523 3 12 3.44772 12 4V8.11115C12 8.66343 11.5523 9.11115 11 9.11115H5L5 13H4V9.11115V8.11115V4V3.55447Z"
      />
    </svg>
  )
})

export default Flag
